import AsyncRenderOnScroll from 'components/shared/AsyncRenderOnScroll'
import { IEmployee } from 'interface/employee'
import { fetchUserAvatar } from 'services/calendar'

interface IRenderParticipantProps {
  participant: IEmployee
}

export const RenderParticipant: React.FC<IRenderParticipantProps> = ({
  participant,
}) => {
  if (participant?.external_id) {
    return (
      <AsyncRenderOnScroll
        loadingComponent={
          <div className="w-[32px] h-[32px] rounded-full bg-ui-gray-200 flex items-center justify-center">
            <img
              src="/assets/image/avatar/loading.gif"
              alt={participant.name[0]}
              className="w-[10px]"
            />
          </div>
        }
        fetchData={async () => {
          const response = await fetchUserAvatar(participant.external_id, true)
          return response.result.avatarBase64
            ? `data:image/png;base64,${response.result.avatarBase64}`
            : null
        }}
        render={(data) => {
          return data ? (
            <img className="w-[32px] h-[32px] rounded-full" src={data} alt="" />
          ) : (
            <div className="w-[32px] h-[32px] rounded-full bg-ui-gray-200 flex items-center justify-center">
              {participant.name[0]}
            </div>
          )
        }}
      />
    )
  }
  return (
    <div className="w-[32px] h-[32px] rounded-full bg-ui-gray-200 flex items-center justify-center">
      {participant.name[0]}
    </div>
  )
}
